import { Doc } from '@dadohr/shared/domainTypes/document';
import { IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { Button, Card } from '@material-ui/core';
import { useDialogState } from '../../../../../../../hooks/useDialogState';
import { CanvasBar } from '../../../../../../../layout/Canvas';
import { Centered } from '../../../../../../../layout/Centered';
import { Section } from '../../../../../../../layout/Section';

export const Timeline = ({
  tpl,
  org
}: {
  tpl: Doc<IExperienceTemplate>;
  org: Doc<IOrganization>;
}) => {
  const preview = useDialogState();
  return (
    <Section>
      <CanvasBar>
        <div>Timeline</div>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={preview.openDialog}
          disabled={true}
        >
          {'Preview (not implemented atm)'}
        </Button>
      </CanvasBar>
      <Card>
        <Centered height={200}>Coming soon.</Centered>
      </Card>
    </Section>
  );
};
